export default "__VITE_ASSET__CpdB_wIB__"